<template>
    <div class="title_bar" :class="{ hide: !show, android: android }">
        <div class="title_bar_content">
            <div class="left">
                <slot name="left">
                    <div @click="goBack" class="back_img">
                        <img v-if="type == 'back'" src="../../assets/imgs/title_back.png" />
                        <img v-else-if="type == 'close'" src="../../assets/imgs/title_close.png" />
                    </div>
                </slot>
            </div>
            <div class="title">
                <slot name="title">
                    <span>{{ title }}</span>
                </slot>
            </div>
            <div class="right"><slot name="right"></slot></div>
        </div>
        <div class="more"><slot name="more"></slot></div>
    </div>
</template>

<script>
export default {
    props: {
        show: {
            default() {
                return true
            }
        },
        type: {
            default() {
                return "back"
            }
        },
        isComment: {
            type: Boolean,
            default: false
        },
        to: "",
        title: "",
        backCb: ""
    },
    computed: {
        android() {
            return window.system === "android"
        }
    },
    methods: {
        goBack() {
            this.$root.eventBus.$emit("hideLoading")
            if (this.to) {
                this.$router.push(this.to)
            } else if (this.backCb) {
                this.backCb()
            } else {
                this.$router.go(-1)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.title_bar {
    &.android {
        padding-top: 1.1rem !important; //ios_top
    }
    position: fixed;
    left: 0;
    top: 0;
    padding-top: 1rem; //ios_top
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    z-index: 111;
    width: 100%;
    box-sizing: border-box;
    background: #edeff1;
    transition: all ease 300ms;
    box-shadow: 0 1px 2px rgba(150, 150, 150, 0.3);

    &.hide {
        transform: translateY(-100%);
        top: 0;
    }

    .title_bar_content {
        height: 2.35rem;
        width: 100%;
        position: relative;
        .left {
            float: left;
            text-align: left;
            width: 2rem;
            height: 100%;
            margin-left: 0.7rem;
            font-size: 0.7rem;
            .back_img {
                position: relative;
                height: 100%;
                img {
                    opacity: 0.7;
                    width: 0.9rem;
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translate(0, -50%);
                }
            }
        }
        .title {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 9rem;
            font-size: 0.9rem;
            opacity: 0.7;
            overflow: hidden;
            text-align: center;
            span {
                width: 100%;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                display: block;
            }
        }
        .right {
            position: absolute;
            right: 0.75rem;
            top: 50%;
            transform: translate(0, -50%);
            font-size: 0.7rem;
            text-align: right;
        }
    }
}
</style>
